import React from 'react'

interface BreadcrumbsProps {
  children: React.ReactNode
  className?: string
  'aria-label'?: string
  separator?: string | React.ReactNode
  [key: string]: unknown
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  children,
  className = '',
  'aria-label': ariaLabel = 'breadcrumb',
  separator = '/',
  ...props
}) => {
  const childrenArray = React.Children.toArray(children).filter(Boolean)

  return (
    <nav aria-label={ariaLabel} className={className} {...props}>
      <ol className="flex flex-wrap items-center list-none p-0 m-0" data-testid="breadcrumb-list">
        {childrenArray.map((child, index) => {
          const isLast = index === childrenArray.length - 1

          return (
            <li key={index} className="flex items-center" data-testid="breadcrumb-list-item">
              {child}
              {!isLast && (
                <span className="mx-2 text-gray-400 select-none" aria-hidden="true">
                  {separator}
                </span>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
